import { styled } from 'styled-components';
import Icons from '../../Elements/Icons/index.js';
export const ClearableInputContainer = styled.div `
  position: relative;
`;
export const ClearIcon = styled(Icons.Reset) `
  display: block;
`;
export const IconButton = styled.button `
  padding: 5px;
  border: none;
  background: none;
  position: absolute;
  width: 20px;
  height: 20px;
  right: 8px;
  top: 0;
  bottom: 0;
  margin: auto;
  cursor: pointer;

  ${ClearIcon} {
    fill: ${({ theme }) => theme.colors.grey100_1};
    transition: fill 0.15s;
  }
`;
